export const customizeCdnLink = (path: string, key: string) =>
  `https://cdn.qrcodecreator.com/editor/${path}/${key}.svg`;
